module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"bindTimeStamp":"Привязать к временной метке"}}')
  delete Component.options._Ctor
}
